var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSofa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.02995 11.6667C4.73719 11.6667 5.41547 11.9476 5.91557 12.4477C6.41566 12.9478 6.69661 13.6261 6.69661 14.3333V17H20.0299V14.3333C20.0299 13.6261 20.3109 12.9478 20.811 12.4477C21.3111 11.9476 21.9894 11.6667 22.6966 11.6667M4.02995 11.6667C3.3227 11.6667 2.64443 11.9476 2.14433 12.4477C1.64423 12.9478 1.36328 13.6261 1.36328 14.3333V19.6667C1.36328 20.3739 1.64423 21.0522 2.14433 21.5523C2.64443 22.0524 3.3227 22.3333 4.02995 22.3333H22.6966C23.4039 22.3333 24.0821 22.0524 24.5822 21.5523C25.0823 21.0522 25.3633 20.3739 25.3633 19.6667V14.3333C25.3633 13.6261 25.0823 12.9478 24.5822 12.4477C24.0821 11.9476 23.4039 11.6667 22.6966 11.6667M4.02995 11.6667V5C4.02995 3.93913 4.45138 2.92172 5.20152 2.17157C5.95167 1.42143 6.96908 1 8.02995 1H18.6966C19.7575 1 20.7749 1.42143 21.525 2.17157C22.2752 2.92172 22.6966 3.93913 22.6966 5V11.6667M5.36328 22.3333V25M21.3633 22.3333V25",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSofa);
export default __webpack_public_path__ + "static/media/sofa.6049afeaa0d892cda86650887e0bc6da.svg";
export { ForwardRef as ReactComponent };